/* eslint-disable no-param-reassign */
import { getCookieValue, setCookieValue } from '@klokhuis/utilities/Cookies';

import {
  AnalyticsUserProperties,
  AnalyticsCookie,
  AnalyticsSession,
} from '../types';

let urlSearchParams: URLSearchParams | null = null;

export function getParamFromUrl(query: string) {
  if (!urlSearchParams) {
    urlSearchParams = new URLSearchParams(window.location.search);
  }

  return urlSearchParams.get(query) || '';
}

export function setUtmEventData(userProperties: AnalyticsUserProperties) {
  const source = getParamFromUrl('utm_source');
  const medium = getParamFromUrl('utm_medium');
  const term = getParamFromUrl('utm_term');
  const content = getParamFromUrl('utm_content');
  const campaign = getParamFromUrl('utm_campaign');

  if (source) {
    userProperties.utm_source = source;
  }

  if (medium) {
    userProperties.utm_medium = medium;
  }

  if (term) {
    userProperties.utm_term = term;
  }

  if (content) {
    userProperties.utm_content = content;
  }

  if (campaign) {
    userProperties.utm_campaign = campaign;
  }
  return userProperties;
}

export function getCurrentSource(): string {
  const source = getParamFromUrl('utm_source');
  const medium = getParamFromUrl('utm_medium');
  const ref = window.document.referrer;

  if (source || medium) {
    let result = '';
    if (source) {
      result = source;
    }
    if (medium) {
      if (result === '') {
        result = medium;
      } else {
        result = `${result}/${medium}`;
      }
    }
    return result;
  }

  if (
    ref === '' ||
    ref === undefined ||
    ref.match(/https?:\/\/(.*)klokhuis.nl/) !== null
  ) {
    return 'Direct';
  }

  const googleSites = [
    /https?:\/\/(.*)google.([^/?]*)/,
    /(.*)com.google.android.googlequicksearchbox(.*)/,
    /(.*)com.google.android.gm(.*)/,
  ];

  if (googleSites.some(site => ref.match(site) !== null)) {
    return 'Google';
  }

  const otherSearchEngines = [
    /https?:\/\/(.*)bing\.([^/?]*)/,
    /https?:\/\/(.*)yahoo.([^/?]*)/,
    /https?:\/\/(.*)baidu.([^/?]*)/,
    /https?:\/\/(.*)yandex.([^/?]*)/,
    /https?:\/\/(.*)ecosia.org/,
    /https?:\/\/(.*)duckduckgo.([^/?]*)/,
  ];

  if (otherSearchEngines.some(engine => ref.match(engine) !== null)) {
    return 'Other search';
  }

  if (ref.match(/https?:\/\/(.*)youtube.com/) !== null) {
    return 'Youtube';
  }

  if (ref.match(/https?:\/\/(.*)live.com/) !== null) {
    return 'Email';
  }

  if (ref.match(/([a-z-]+):\/\/(.*).facebook.(.*)/) !== null) {
    return 'Facebook';
  }

  if (ref.match(/https?:\/\/(.*)twitter.([^/?]*)/) !== null) {
    return 'Twitter';
  }

  return 'Other';
}

export function setSourceData(userProperties: AnalyticsUserProperties) {
  // If no session for currentSource is found, initialize it.
  // It will hold the value of currentSource for the entire session
  let currentSource = sessionStorage.getItem(AnalyticsSession.CurrentSource);

  if (!currentSource) {
    currentSource = getCurrentSource();
    sessionStorage.setItem(AnalyticsSession.CurrentSource, currentSource);
  }

  // Get initial source. If none found, intialize to current source.
  let source = getCookieValue(AnalyticsCookie.FirstSource);
  if (!source) {
    source = currentSource;
    setCookieValue(AnalyticsCookie.FirstSource, currentSource, 30);
  }

  userProperties.source = source;
  userProperties.currentSource = currentSource;
  userProperties.path = window.location.pathname;

  return userProperties;
}

export function getUserProperties() {
  const userProperties = {};

  setUtmEventData(userProperties);
  setSourceData(userProperties);
  return userProperties;
}
